export const department = {
    hssShort: "인문",
    aeShort: "항공",
    bisShort: "바공",
    bsShort: "생명",
    cbeShort: "생화공",
    ceShort: "건환",
    chShort: "화학",
    csShort: "전산",
    eeShort: "전자",
    idShort: "산디",
    ieShort: "산공",
    masShort: "수리",
    meShort: "기계",
    nqeShort: "원양",
    btmShort: "기경",
    msShort: "신소재",
    phShort: "물리",
    tsShort: "융인",
    ssShort: "반시공",
    bcsShort: "뇌인지",
    aicShort: "AI컴",
    etcShort: "기타",
}
